import React from 'react';
import { Icons } from '@ohif/ui-next';

interface ButtonContentProps {
  hasPending: boolean;
  isFullyReviewed: boolean;
}

export default function ButtonContent({ hasPending, isFullyReviewed }: ButtonContentProps) {
  if (hasPending) {
    return (
      <Icons.LoadingSpinner aria-hidden="true" />
    );
  }

  if (isFullyReviewed) {
    return (
      <Icons.StatusTracking
        aria-hidden="true"
        className="h-5 w-5"
      />
    );
  }

  return (
    <Icons.ToolDicomTagBrowser
      aria-hidden="true"
      className="h-5 w-5"
    />
  );
}
